<template>
  <div class="relative">
    <!-- Bell -->
    <button
      type="button"
      class="relative cursor-pointer"
      aria-label="Notifications"
      @click="openModal"
    >
      <i class="bi bi-bell-fill text-primary text-2xl"></i>

      <!-- Numeric badge -->
      <span
        v-if="unreadCount > 0"
        class="badge badge-xs rounded-full bg-red-500 text-white px-1.5 border-none text-[10px] absolute -top-1 -right-1"
      >
        {{ badgeText }}
      </span>
    </button>

    <!-- Only the modal component lives here -->
    <NotificationsModal ref="modalRef" />
  </div>
</template>

<script setup>
import {computed, onBeforeUnmount, onMounted, ref} from "vue";
import {useAuthStore, useNotificationsStore} from "@/stores";
import NotificationsModal from "@/components/atoms/NotificationsModal.vue";
import {storeToRefs} from "pinia";

const notificationsStore = useNotificationsStore();
const authStore = useAuthStore()
const user = computed(() => authStore.user)
const {notifications} = storeToRefs(notificationsStore);
const socket = ref(null)
const BASE_WS_URL = import.meta.env.VITE_BASE_WS_URL || 'ws://localhost:8000'
const modalRef = ref(null);

const unreadCount = computed(() => notificationsStore.unreadCount || 0);
const badgeText = computed(() =>
  unreadCount.value > 99 ? "99+" : String(unreadCount.value)
);

const updateOrInsertNotification = (newNotification) => {
  const index = notifications.value.findIndex(notification => notification.id === newNotification.id)
  if (index >= 0) {
    notifications.value[index] = newNotification
  } else {
    notifications.value.unshift(newNotification)
  }
}

const deleteNotification = (newNotification) => {
  const index = notifications.value.findIndex(notification => notification.id === newNotification.id)
  if (index >= 0) {
    notifications.value.splice(index, 1)
  }
}
onMounted(async () => {
  await notificationsStore.fetchNotifications()

  try {
    socket.value = new WebSocket(`${BASE_WS_URL}/ws/notifications/`)
  } catch (error) {
    console.error('❌ WebSocket creation failed:', error)
    return
  }

  socket.value.onmessage = (event) => {
    const data = JSON.parse(event.data)
    console.log("📨 WebSocket message:", data)
    if (!user.value) return
    if (!(data.notification.recipients??[user.value.id]).includes(user.value.id)) return
    if (['notification_update','notification_create'].includes(data.type)) {
      updateOrInsertNotification(data.notification)
    } else if (data.type === 'notification_delete') {
      deleteNotification(data.notification)
    } else if (data.type === 'notifications_list') {
      notifications.value = data.notifications
    }
  }

  socket.value.onopen = () => {
    console.log('✅ WebSocket connected');
    notificationsStore.websocketConnected = true
  }

  socket.value.onerror = (error) => {
    console.error('❌ WebSocket error:', error);
  }
})

onBeforeUnmount(() => {
  if (socket.value) socket.value.close()
})

function openModal() {
  modalRef.value?.open?.(); // calls defineExpose({ open }) in NotificationsModal
}
</script>